"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const native_1 = require("@react-navigation/native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const eventConstants_1 = require("../../constants/eventConstants");
const styles_1 = __importDefault(require("../../styles/styles"));
const screenConstants_1 = require("../../constants/screenConstants");
const pressable_1 = __importDefault(require("../pressable/pressable"));
const icon_1 = __importDefault(require("../icon/icon"));
const button_1 = __importDefault(require("../button/button"));
const colors_1 = __importDefault(require("../../styles/colors"));
const notificationsUtils_1 = __importDefault(require("./notificationsUtils"));
const notificationSlice_1 = require("../../features/notifications/notificationSlice");
const notificationConstants_1 = require("../../features/notifications/notificationConstants");
const eventSlice_1 = require("../event/eventSlice");
const eventConstants_2 = require("../event/eventConstants");
const browserNotificationUtils_1 = require("../browserNotification/browserNotificationUtils");
const messageModalConstant_1 = require("../messageModal/messageModalConstant");
const messageModal_1 = __importDefault(require("../messageModal/messageModal"));
const analytics_1 = require("../../utils/analytics");
const NotificationBadge = () => {
    const dispatch = useAppDispatch_1.default();
    const navigator = native_1.useNavigation();
    const { notifications, token, eventSocket } = useAppSelector_1.default((state) => ({
        notifications: state.notifications.notifications,
        token: state.auth.token,
        eventSocket: state.event.socket,
    }));
    // State to control visibility of notifications list modal
    const [notificationsListVisible, setNotificationListVisible] = react_1.useState(false);
    const [errorMessage, setErrorMessage] = react_1.useState('');
    // Filter active notifications
    const activeNotifications = notifications.filter((notification) => notification.active);
    const onNotificationPress = (notification) => {
        // Close the list first
        setNotificationListVisible(false);
        notificationsUtils_1.default(notification, dispatch, navigator);
    };
    const viewAllNotifications = () => {
        setNotificationListVisible(false);
        navigator.navigate(screenConstants_1.NOTIFICATIONS_SCREEN);
    };
    const notificationIcon = (react_1.default.createElement(pressable_1.default, { onPress: () => setNotificationListVisible(!notificationsListVisible), eventName: eventConstants_1.NOTIFICATION_PRESS },
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow] },
            react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faBell, size: 30 }),
            react_1.default.createElement(react_native_paper_1.Badge, { visible: activeNotifications.length > 0, size: 20 }, activeNotifications.length))));
    // Ensure we only have today's active notifications shown in badge
    const getTodayNotifications = () => {
        const today = new Date().toISOString().split('T')[0];
        dispatch(notificationSlice_1.getNotifications({ send_at: today }));
    };
    native_1.useFocusEffect(react_1.useCallback(() => {
        dispatch(eventSlice_1.newSocket({ token }));
        // Lets close the connection when an agent leaves this screen.
        return () => {
            dispatch(eventSlice_1.resetSocketState());
        };
    }, []));
    react_1.useEffect(() => {
        // We only want to continue if there is the socket connection is ready to receive a message.
        if (!eventSocket || eventSocket.readyState !== 1)
            return;
        // Define messageHandler to handle incoming messages
        const messageHandler = (event) => {
            analytics_1.logEvent(eventConstants_1.NEW_MESSAGE_EVENT);
            const payload = JSON.parse(event.data);
            const eventType = payload.type;
            // Display browser notification
            if (eventType === eventConstants_2.NOTIFICATION) {
                analytics_1.logEvent(eventConstants_1.NEW_NOTIFICATION_MESSAGE_EVENT);
                const notification = payload.notification;
                const message = {
                    tag: `${notification.id}`,
                    title: `${notificationConstants_1.NOTIFICATION_TITLES.get(notification.content_type) ||
                        notification.content_type}: ${new Date(notification.send_at).toLocaleTimeString()}`,
                    body: notification.message,
                };
                browserNotificationUtils_1.showBrowserNotification(message, setErrorMessage);
                // Fetch notifications to get latest notifications to update the active notification badge count
                getTodayNotifications();
            }
        };
        eventSocket.addEventListener('message', messageHandler);
    }, [eventSocket, eventSocket && eventSocket.readyState]);
    react_1.useEffect(() => {
        getTodayNotifications();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        errorMessage && react_1.default.createElement(messageModal_1.default, { message: errorMessage, type: messageModalConstant_1.WARNING_MESSAGE }),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.marginTen] },
            react_1.default.createElement(react_native_paper_1.Menu, { visible: notificationsListVisible, onDismiss: () => setNotificationListVisible(!notificationsListVisible), anchor: notificationIcon, contentStyle: [styles_1.default.whiteBackground, styles_1.default.marginTopForty] },
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(react_native_1.View, { style: [
                            styles_1.default.marginTen,
                            styles_1.default.flexDirectionRow,
                            styles_1.default.alignSpaceBetween,
                            styles_1.default.alignItemsCenter,
                        ] },
                        react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.fontWeightBold] }, `Notifications `),
                        activeNotifications.length > 0 && (react_1.default.createElement(react_native_paper_1.Chip, { style: styles_1.default.blueBackground }, `${activeNotifications.length} active`))),
                    activeNotifications.length > 0 &&
                        activeNotifications.map((notification) => (react_1.default.createElement(pressable_1.default, { onPress: () => onNotificationPress(notification), eventName: eventConstants_1.VIEW_NOTIFICATION_ITEM, key: notification.id },
                            react_1.default.createElement(react_native_paper_1.Card.Title, { style: [styles_1.default.bottomBorder, { borderColor: colors_1.default.BORDER_COLOR }], left: () => (react_1.default.createElement(react_native_paper_1.Avatar.Icon, { size: 50, icon: notificationConstants_1.NOTIFICATION_TYPE_ICONS.get(notification.content_type) || 'bell', style: [styles_1.default.blueBackground] })), title: notificationConstants_1.NOTIFICATION_TITLES.get(notification.content_type) ||
                                    notification.content_type, titleStyle: [styles_1.default.textTitle, styles_1.default.fontWeightBold], subtitle: `${new Date(notification.send_at).toLocaleTimeString()} : ${notification.message}`, subtitleStyle: styles_1.default.textTitle, right: () => (react_1.default.createElement(react_native_paper_1.IconButton, { size: 10, style: [styles_1.default.redBackground, { opacity: 0.8 }], icon: "close", iconColor: colors_1.default.WHITE, onPress: () => {
                                        dispatch(notificationSlice_1.updateNotification({
                                            notification_id: notification.id,
                                            read: true,
                                        }));
                                    } })), rightStyle: styles_1.default.marginRightTen })))),
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginTen] },
                        react_1.default.createElement(button_1.default, { onPress: viewAllNotifications, fill: true, eventName: eventConstants_1.VIEW_ALL_NOTIFICATIONS_BUTTON, text: "View All" })))))));
};
exports.default = NotificationBadge;
